/**
 * Format a date string to a more readable format (e.g., "June 14, 2025").
 *
 * @param dateString  An ISO-ish date string (e.g. "2025-06-14T12:00:00Z"). If falsy or invalid, returns "".
 * @param locale      A BCP 47 locale string (e.g. "en-US", "es-MX"). Defaults to "en-US".
 * @returns           A formatted date like "June 14, 2025", or empty string on invalid input.
 */
export const formatDate = (dateString?: string, locale: string = 'en-US'): string => {
  if (!dateString) return '';

  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
      return '';
    }

    return date.toLocaleDateString(locale, {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  } catch (error) {
    console.error('Error formatting date:', error);
    return '';
  }
};
